export const CLOCK_ACTIONS = {
    CLOCK_IN: 'CLOCK_IN',
    CLOCK_OUT: 'CLOCK_OUT',
};

export const SHIFT_EXCEPTION_STATUS = {
    ARCHIVED: 'ARCHIVED',
    ACTIVE: 'ACTIVE',
};

export const SHIFT_EXCEPTION_CODE = {
    FINAL_FAIR_WORK_WEEK_PENALTY: 'FINAL_FAIR_WORK_WEEK_PENALTY',
    CALL_IN: 'CALL_IN',
};

export const ERRORS = {
    CLOCK_ENTRY_DELETED: 'CLOCK_ENTRY_DELETED',
    CLOCK_ENTRY_RUNNING: 'CLOCK_ENTRY_RUNNING',
    CLOCK_IN_OUT_OF_RANGE: 'CLOCK_IN_OUT_OF_RANGE',
    USER_NOT_HIRED: 'USER_NOT_HIRED',
    CLOCK_ENTRY_MARKED_NOW_SHOW: 'CLOCK_ENTRY_MARKED_NOW_SHOW',
    CLOCK_ENTRY_RESOLVED: 'CLOCK_ENTRY_RESOLVED',
    OPTIMISTIC_LOCK_EXCEPTION: 'OPTIMISTIC_LOCK_EXCEPTION',
    UPDATED_TIMECARD: 'UPDATED_TIMECARD',
    SHIFT_NOT_FOUND: 'SHIFT_NOT_FOUND',
    UNAUTHORIZED_CATEGORY: 'UNAUTHORIZED_CATEGORY',
    UPDATED_FROM_OTHER: 'UPDATED_FROM_OTHER',
    BREAK_END_TIME_IN_FUTURE: 'BREAK_END_TIME_IN_FUTURE',
    BREAK_TIME_OUT_OF_CLOCK: 'BREAK_TIME_OUT_OF_CLOCK',
    OVERLAPPING_BREAKS: 'OVERLAPPING_BREAKS',
    INVALID_BREAK_TIMES: 'INVALID_BREAK_TIMES',
    INTERLEAVING_BREAK_WITH_CLOCK: 'INTERLEAVING_BREAK_WITH_CLOCK',
    PAYSHEET_CLOSED: 'PAYSHEET_CLOSED',
    RUNNING_BREAK_OUT_OF_CLOCK_INTERVAL: 'RUNNING_BREAK_OUT_OF_CLOCK_INTERVAL',
    UNAUTHORIZED: 'UNAUTHORIZED',
};

export const CLOCKS_VIOLATIONS = {
    OVERTIME: 'OVERTIME',
    BREAKS_PREMIUMS: 'BREAKS_PREMIUMS',
    SPREAD_OF_HOURS: 'SPREAD_OF_HOURS',
    REPORTING_TIME: 'REPORTING_TIME',
    SPLIT_SHIFT: 'SPLIT_SHIFT',
    FWW: 'FWW',
    RTR: 'RTR',
    PHOTO_ISSUES: 'PHOTO_ISSUES',
    PH_REST_DAY: 'PH_REST_DAY',
    EMPLOYER_IGNORE: 'EMPLOYER_IGNORE',
    EMPLOYEE_IGNORED: 'EMPLOYEE_IGNORED',
    BREAKS_PREMIUMS_IGNORED_BY_WAIVER_ON_FILE: 'BREAKS_PREMIUMS_IGNORED_BY_WAIVER_ON_FILE'
}

export const USER_PAY_TYPE = {
    HOURLY: 'HOURLY',
    SALARIED: 'SALARIED',
    WEIGHTED_SHIFT: 'WEIGHTED_SHIFT',
};